import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            热门分类
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            探索你感兴趣的内容
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            八大内容分类，总有一个适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group relative p-5 rounded-2xl bg-background-50 border border-background-200/70 hover:shadow-sm hover:-translate-y-1 transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div className={`absolute top-0 right-0 w-20 h-20 rounded-bl-full bg-gradient-to-br ${category.color} opacity-10 group-hover:opacity-20 transition-opacity duration-300`}></div>
              <div className="relative z-10">
                <div className={`w-11 h-11 rounded-xl bg-gradient-to-br ${category.color} flex items-center justify-center mb-3`}>
                  <i className={`${category.icon} text-lg text-background-50`}></i>
                </div>
                <h3 className="text-sm font-heading font-semibold text-foreground-950 mb-1 whitespace-nowrap">
                  {category.name}
                </h3>
                <p className="text-xs text-foreground-500">
                  {category.videoCount.toLocaleString()} 个视频
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}